import firebase from '../../firebase.js';
var db = firebase.firestore();
export default {
    name: 'Comments',
    data() {
        return {
            comments: [],
            messageSnackbar: false,
            message: ''
        };
    },
    methods: {
        approve(id, key) {
            db.doc('/comments/' + id)
                .update({
                    approved: true
                })
                .then(
                    function() {
                        this.comments.splice(key, 1);
                    }.bind(this)
                )
                .catch(
                    function(error) {
                        this.message =
                            'There was an error approving this comment';
                        this.messageSnackbar = true;
                        console.error('Error writing document: ', error);
                    }.bind(this)
                );
        },
        reject(id, key) {
            db.doc('/comments/' + id)
                .delete()
                .then(
                    function() {
                        this.comments.splice(key, 1);
                    }.bind(this)
                )
                .catch(function(error) {
                    this.message = 'There was an error rejecting this comment';
                    this.messageSnackbar = true;
                    console.error('Error removing document: ', error);
                });
        }
    },
    created() {
        db.collection('comments')
            .where('approved', '==', false)
            .get()
            .then(
                function(querySnapshot) {
                    querySnapshot.forEach(doc => {
                        let data = doc.data();
                        data.id = doc.id;
                        this.comments.push(data);
                    });
                }.bind(this)
            );
    }
};



// WEBPACK FOOTER //
// ./src/components/comments/comments.js